/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyStatusesDropdown200,
  GetApiV1AssociatedcompanyStatusesDropdown401,
  GetApiV1AssociatedcompanyStatusesDropdown500,
  GetApiV1AssociatedcompanyStatusesDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyStatusesDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyStatusesDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyStatusesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyStatusesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyStatusesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyStatusesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyStatusesDropdown500>;

export const getApiV1AssociatedcompanyStatusesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyStatusesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyStatusesDropdownQueryResponse>;
